import { render, staticRenderFns } from "./trialBalanceModalArchive.vue?vue&type=template&id=56166693&scoped=true"
import script from "./trialBalanceModalArchive.vue?vue&type=script&lang=js"
export * from "./trialBalanceModalArchive.vue?vue&type=script&lang=js"
import style0 from "./trialBalanceModalArchive.vue?vue&type=style&index=0&id=56166693&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56166693",
  null
  
)

export default component.exports